import React, { useEffect, useState } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import Terms from "./terms";
import Tenants from "./tenants";
import RentCharges from "./rentCharges";
import RentSchedule from "./rentSchedule";
import Deposite from "./deposite";
import Esignature from "./lateFee";
import Overview from "./overview";
import { useSelector, useDispatch } from "react-redux";
import * as LeaseAction from "../../../../store/actions/lease/LeaseAction";
import { initializeAdditionalTerms } from "../../../template/flexIndustrialLeaseAdditionalTermsCheckboxes";
const CreateMain = ({ onBack }) => {
  const steps = ["Property", "Tenant", "Rent", "Rent Schedule", "Deposit", "Signature", "Overview"];
  const dispatch = useDispatch();
  const { leaseCreateStep } = useSelector((state) => state.lease);
  const { leaseData, leaseUpdate, isRenewal } = useSelector(
    (state) => state.lease
  );

  console.log("CreateMain component - isRenewal:", isRenewal);

  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );
  const handleStepClick = (step) => {
    dispatch(LeaseAction.ChangePropertyCreateSteps(step));
    // setleaseCreateStep(step);
  };

  function generatePassword() {
    const length = 5;
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      password += characters[randomIndex];
    }
    return `FLEX${password}`;
  }

  const [formFields, setFormFields] = useState({
    propertyInfo: null,
    unitInfo: null,
    leaseTerm: "Pre Rent",
    startDate: null,
    endDate: null,
    annualIncrementPercentage: "",
    isFirstMonthFree: false,

    rentStartDate: null,
    rentFrequency: "Monthly",
    chargeLate: false,
    latePercentage: "",
    graceDays: "",
    lateFixedAmount: 500,
    lateInterestRate: 5,
    additionalCharges: [],

    securityDeposit: false,
    securityDepositAmount: 0,

    rentSchedule: [],

    additionalTerms: initializeAdditionalTerms(),

    isEsignature: false,
    eSignature: null,
    drawSignature: true,
    deliveryConditions: {
      broomClean: false,
      hvacOperational: false,
      electricalOperational: false,
      rollUpDoorsOperational: false,
      restroomFixturesOperational: false,
    },
  });

  useEffect(() => {
    if (leaseUpdate) {
      setFormFields((prevFields) => ({
        ...prevFields,
        propertyInfo: leaseData.propertyInfo,
        unitInfo: leaseData.unitInfo, // Backend now provides latest unitInfo automatically
        leaseTerm: leaseData.leaseTerm || "Pre Rent",
        startDate: isRenewal ? null : leaseData.startDate,
        endDate: isRenewal ? null : leaseData.endDate,
        annualIncrementPercentage: leaseData.annualIncrementPercentage || "",
        isFirstMonthFree: !!leaseData.isFirstMonthFree,
        rentStartDate: isRenewal ? null : leaseData.rentStartDate,
        rentFrequency: leaseData.rentFrequency,
        chargeLate: leaseData.chargeLate,
        latePercentage: leaseData.latePercentage,
        graceDays: leaseData.graceDays,
        lateFixedAmount: leaseData.lateFixedAmount ?? 500,
        lateInterestRate: leaseData.lateInterestRate ?? 5,
        additionalCharges: leaseData.additionalCharges,
        securityDeposit: leaseData.securityDeposit,
        securityDepositAmount: leaseData?.securityDepositAmount
          ? leaseData?.securityDepositAmount
          : 0,
        rentSchedule: leaseData.rentSchedule || [],
        additionalTerms: leaseData.additionalTerms && leaseData.additionalTerms.length === 23 
          ? leaseData.additionalTerms 
          : initializeAdditionalTerms(),
        isEsignature: leaseData.isEsignature,
        eSignature: leaseData.eSignature,
        deliveryConditions: leaseData.deliveryConditions || {
          broomClean: false,
          hvacOperational: false,
          electricalOperational: false,
          rollUpDoorsOperational: false,
          restroomFixturesOperational: false,
        },
        brokerInfo: leaseData.brokerInfo || {
          tenantBrokerCheckbox: false,
          tenantBrokerName: '',
          landlordBrokerName: ''
        },
      }));

      setTenantInfo((prevInfo) => ({
        ...prevInfo,
        firstName: leaseData?.tenantInfo?.firstName,
        lastName: leaseData?.tenantInfo?.firstName,
        email: leaseData?.tenantInfo?.email,
        cellNo: leaseData?.tenantInfo?.cellNo,
        password: leaseData?.tenantInfo?.password,
      }));
    }
  }, [leaseUpdate, isRenewal, leaseData]);

  const [tenentInfo, setTenantInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    cellNo: "",
    landlordId: loginSuccess?.user?._id,
    password: generatePassword(),
    // password: "112233"
  });

  return (
    <div className="h-screen">
      <div className="h-[10vh] flex flex-col justify-center">
        <ParagraphTag
          content="Leases"
          classes="text-darkColor font-popinsSemiBold text-2xl"
        />
        <ParagraphTag
          content="Renew or end leases that are expiring soon."
          classes="text-[#686868] font-popinsMedium text-sm"
        />
      </div>

      <div className="h-[90vh] py-3 ">
        <div className="bg-white rounded-md h-full">
          <div className="w-full mx-auto h-[15%]">
            {/* Stepper */}
            <div className="relative w-[70%] mx-auto flex items-center justify-between pt-5">
              {/* Step Circles */}
              {steps.map((step, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center w-full relative"
                >
                  {/* Circle */}
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-full border-2 ${
                      leaseCreateStep === index + 1
                        ? "border-[#0381CA] bg-white text-[#0381CA]"
                        : leaseCreateStep > index + 1
                        ? "border-[#0381CA] bg-[#0381CA] text-white"
                        : "border-gray-300 bg-white text-gray-500"
                    } font-popinsMedium cursor-pointer transition-all`}
                    onClick={() => handleStepClick(index + 1)}
                  >
                    {index + 1}
                  </div>

                  {/* Step Label */}
                  <p
                    className={`mt-1 text-xs font-popinsRegular text-[#686868] ${
                      leaseCreateStep >= index + 1
                        ? "text-[#0381CA]"
                        : "text-gray-500"
                    }`}
                  >
                    {step}
                  </p>

                  {/* Line Connector */}
                  {index < steps.length - 1 && (
                    <div
                      className={`absolute top-4 left-[calc(50%+16px)] right-[calc(-50%+16px)] h-0.5 ${
                        leaseCreateStep > index + 1
                          ? "bg-[#0381CA]"
                          : "bg-gray-300"
                      }`}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="h-[85%]">
            {leaseCreateStep === 1 && (
              <Terms
                selectedProperty={
                  formFields?.propertyInfo?.propertyName
                    ? formFields?.propertyInfo?.propertyName
                    : "Please select a property"
                }
                selectedUnit={
                  formFields?.unitInfo?.unitName
                    ? formFields?.unitInfo?.unitName
                    : "Please select a unit"
                }
                formData={formFields}
                onUnitSelect={(item) => {
                  setFormFields({
                    ...formFields,
                    unitInfo: item,
                  });
                }}
                onPropertySelect={(item) => {
                  setFormFields({
                    ...formFields,
                    propertyInfo: item,
                  });
                }}
              />
            )}

            {leaseCreateStep === 2 && (
              <Tenants
                onFirstNameChange={(e) => {
                  setTenantInfo({
                    ...tenentInfo,
                    firstName: e.target.value,
                  });
                }}
                onLastNameChange={(e) => {
                  setTenantInfo({
                    ...tenentInfo,
                    lastName: e.target.value,
                  });
                }}
                onEmailAddressChange={(e) => {
                  setTenantInfo({
                    ...tenentInfo,
                    email: e.target.value,
                  });
                }}
                onCellNumberChange={(e) => {
                  setTenantInfo({
                    ...tenentInfo,
                    cellNo: e.target.value,
                  });
                }}
                formData={tenentInfo}
              />
            )}

            {leaseCreateStep === 3 && (
              <RentCharges
                formData={formFields}
                isChargeLate={(bool) => {
                  setFormFields({
                    ...formFields,
                    chargeLate: bool,
                  });
                }}
                onLatePercentageChange={(e) => {
                  setFormFields({
                    ...formFields,
                    latePercentage: e.target.value === '' ? '' : Number(e.target.value),
                  });
                }}
                onLateGraceDays={(e) => {
                  setFormFields({
                    ...formFields,
                    graceDays: e.target.value === '' ? '' : Number(e.target.value),
                  });
                }}
                onLateFixedAmountChange={(e) => {
                  setFormFields({
                    ...formFields,
                    lateFixedAmount: e.target.value === '' ? 500 : Number(e.target.value),
                  });
                }}
                onLateInterestRateChange={(e) => {
                  setFormFields({
                    ...formFields,
                    lateInterestRate: e.target.value === '' ? 5 : Number(e.target.value),
                  });
                }}
                onAdditionalCharges={(data) => {
                  let preeList = formFields.additionalCharges;
                  preeList.push(data);
                  setFormFields({
                    ...formFields,
                    additionalCharges: preeList,
                  });
                }}
                onItemDeleteChanges={(item) => {
                  let list = [...formFields.additionalCharges];
                  list = list.filter((i) => i.title !== item.title);
                  setFormFields({
                    ...formFields,
                    additionalCharges: list,
                  });
                }}
              />
            )}
            {leaseCreateStep === 4 && (
              <RentSchedule
                formData={formFields}
                onStartDate={(date) => {
                  setFormFields({
                    ...formFields,
                    startDate: date,
                    rentStartDate: date,
                  });
                }}
                onEndDate={(date) => {
                  setFormFields({
                    ...formFields,
                    endDate: date,
                  });
                }}
                onAnnualIncrementChange={(value) => {
                  setFormFields({
                    ...formFields,
                    annualIncrementPercentage: value,
                  });
                }}
                onRentFrequencyChange={(value) => {
                  setFormFields({
                    ...formFields,
                    rentFrequency: value,
                  });
                }}
                onRentScheduleChange={(schedule) => {
                  setFormFields((prev) => ({
                    ...prev,
                    rentSchedule: Array.isArray(schedule) ? schedule : [],
                  }));
                }}
                onIsFirstMonthFreeChange={(checked) => {
                  setFormFields((prev) => ({ ...prev, isFirstMonthFree: !!checked }));
                }}
              />
            )}
            {leaseCreateStep === 5 && (
              <Deposite
                formData={formFields}
                onSecurityDepositChange={(value) => {
                  setFormFields({
                    ...formFields,
                    securityDeposit: value,
                  });
                }}
                onDepositAmountChange={(e) => {
                  setFormFields({
                    ...formFields,
                    securityDepositAmount: e.target.value,
                  });
                }}
              />
            )}
            {leaseCreateStep === 6 && (
              <Esignature
                formData={formFields}
                isEsignature={(value) => {
                  setFormFields({
                    ...formFields,
                    isEsignature: value,
                  });
                }}
                signatureObject={(sign) => {
                  setFormFields({
                    ...formFields,
                    eSignature: sign,
                  });
                }}
                isDrawSignature={(value) => {
                  setFormFields({
                    ...formFields,
                    drawSignature: value,
                  });
                }}
              />
            )}
            {leaseCreateStep === 7 && (
              <Overview
                tenentInfo={tenentInfo}
                formData={formFields}
                onClose={onBack}
                getCurrentFormData={() => formFields}
                onFormDataChange={(updatedFormData) => {
                  setFormFields(updatedFormData);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateMain;
